import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const K: React.FC = () => {
    const { t } = useLang('ats.K');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-K');

    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current?.querySelector('.title');
        const desc = sectionRef.current?.querySelector('.desc');
        const img = sectionRef.current.querySelector('.img');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
                img?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    img?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} smart-gateway-K GtmModuleData-section`}
                id="smart-gateway-K"
                data-section-id={'smart-gateway-K'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="info">
                    <p className="title ani-1">{t('title')}</p>
                    <p className="desc ani-2">{t.rich('desc', { h: (a: string) => <span className="white">{a}</span> })}</p>
                </div>
                <div className="img ani-3">
                    <EcoImg
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1765182899021/us-ats-pc.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1765182899575/us-ats-pc.webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1765182898728/us-ats-h5.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1765182899222/us-ats-h5.webp',
                        )}
                    />
                </div>
            </section>
        </>
    );
};

export default K;
